import {
  ISSUE_TYPE_ITEMS,
  IssueOrderBy,
  IssueOrderDirection,
} from './constants';

export function reverseIssueOrderDirection(direction: IssueOrderDirection) {
  const { ASC, DESC } = IssueOrderDirection;
  return direction === ASC ? DESC : ASC;
}

export function getFilters(query: Record<string, string>) {
  return {
    actionKeys: query.actions?.split(',') ?? [],
    issueTypeItem:
      query['issue-type'] === 'bug'
        ? ISSUE_TYPE_ITEMS[1]
        : query['issue-type'] === 'feature-request'
        ? ISSUE_TYPE_ITEMS[2]
        : ISSUE_TYPE_ITEMS[0],
    orderBy:
      query['order-by'] === 'created-at'
        ? IssueOrderBy.CREATED_AT
        : IssueOrderBy.PRIORITY,
    direction:
      query.direction === 'asc'
        ? IssueOrderDirection.ASC
        : IssueOrderDirection.DESC,
    page: query.page ? Number(query.page) - 1 : 0,
    triggerKeys: query.triggers?.split(',') ?? [],
  };
}

export function updateSearchParamsByFilters(
  searchParams: URLSearchParams,
  filter:
    | { actionKeys: string[] }
    | { direction: 'asc' | 'desc' }
    | { issueType: 'all' | 'bug' | 'feature-request' }
    | { orderBy: 'created-at' | 'priority' }
    | { page: string }
    | { triggerKeys: string[] }
) {
  const searchParamsNext = new URLSearchParams(searchParams);

  if ('actionKeys' in filter) {
    if (filter.actionKeys.length) {
      searchParamsNext.set('actions', filter.actionKeys.join(','));
    } else {
      searchParamsNext.delete('actions');
    }
  }
  if ('triggerKeys' in filter) {
    if (filter.triggerKeys.length) {
      searchParamsNext.set('triggers', filter.triggerKeys.join(','));
    } else {
      searchParamsNext.delete('triggers');
    }
  }

  if ('direction' in filter) {
    searchParamsNext.set('direction', filter.direction);
  }
  if ('issueType' in filter) {
    searchParamsNext.set('issue-type', filter.issueType);
  }
  if ('orderBy' in filter) {
    searchParamsNext.set('order-by', filter.orderBy);
  }
  if ('page' in filter) {
    searchParamsNext.set('page', filter.page);
  }

  return searchParamsNext;
}
